import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { genTemplateBodyNumber, genTemplateBodyText } from "../../../../components/utils/TableTemplateBodyGenerator";
import { Tag } from "primereact/tag";
import useIsMobile from "../../../../hooks/useIsMobile";


const TabelService = (props) => {
  const isMobile = useIsMobile();

  const { data } = props;

  const serviceBodyTemplate = (row) => {
    const { data_service } = row;
    let serviceName = data_service?.nama;

    // remove common word to shorten the name
    serviceName = serviceName
      .toLowerCase()
      .replaceAll("ganti", "")
      .replaceAll("service", "")
      .trim();

    // Capitalize first letter of each word
    serviceName = serviceName
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return serviceName;
  };

  const mobilBodyTemplate = (row) => {

    const NoPolisi = genTemplateBodyText({ row, field: "data_kendaraan.nomor_polisi", defaultEmpty: "-" });
    const Jenis = genTemplateBodyText({ row, field: "data_kendaraan.jenis_mobil", defaultEmpty: "" });

    return (
      <div className="col-start-start w-full">
        {/* No Polisi */}
        <div style={{ fontSize: "1rem", fontWeight: "600", color: "#000" }}>
          {NoPolisi}
        </div>

        {/* Jenis */}
        <div
          style={{
            fontSize: "0.83rem",
            color: "#000",
          }}
        >
          {Jenis}
        </div>
      </div>
    );
  };

  const kmAkhirBodyTemplate = (row) => {
    return genTemplateBodyNumber({
      row: row,
      field: "data_kendaraan.speedo_akhir",
      defaultEmpty: false,
    });
  };

  const nextBodyTemplate = (row) => {
    return genTemplateBodyNumber({
      row: row,
      field: "next",

      defaultEmpty: false,
    });
  };

  const statusBodyTemplate = (row) => {
    const km = row?.data_kendaraan?.speedo_akhir ?? 0;
    const next = row?.next ?? 0;
    const diff = next - km;

    // format number with thousand separators (dot)
    const formatted = new Intl.NumberFormat("id-ID").format(diff);

    // decide background color
    const bgColor = diff < 0 ? "bg-red-400" : "bg-orange-400";

    return (
      <Tag
        value={formatted}
        className={`${bgColor} text-black font-semibold px-3 pt-2`}
      />
    );
  };

  const mobileBodyTemplate = (row) => {
    const { data_kendaraan, data_service, last } = row;

    const km = row?.data_kendaraan?.speedo_akhir ?? 0;
    const next = row?.next ?? 0;
    const diff = next - km;
    const lastkm = next - last;

    // format number with thousand separators (dot)
    const formatted = new Intl.NumberFormat("id-ID").format(diff);

    // decide background color
    const bgColor = diff < 0 ? "bg-red-400" : "bg-orange-400";

    return (
      <div className="col-start-start w-full gap-1 p-1">
        {/* --- Header (No Polisi & Jenis Mobil) --- */}
        <div className="row-between-center w-full pb-2 border-b border-stone-200">
          <div className="col-start-start">
            <div className="text-base font-bold text-gray-900">
              {data_kendaraan?.nomor_polisi}
            </div>
            <div className="text-xs text-gray-500">
              {data_kendaraan?.jenis_mobil}
            </div>
          </div>
          <div className="flex items-center gap-1 text-xs text-slate-500">
            <i className="pi pi-wrench text-gray-500" />
            {data_service?.nama}
          </div>
        </div>

        {/* --- Odometer Info --- */}
        <div className="col-start-start gap-2 pt-3">
          <div className="row-start-center gap-2">
            <i className="pi pi-gauge text-gray-500" />
            <span className="text-sm text-gray-600">
              KM:{" "}
              <span className="font-semibold text-gray-900">
                {data_kendaraan?.speedo_akhir.toLocaleString("id-ID")} KM
              </span>
            </span>
          </div>

          <div className="row-start-center gap-2">
            <i className="pi pi-history text-gray-500" />
            <span className="text-sm text-gray-600">
              Last:{" "}
              <span className="font-semibold text-gray-900">
                {last?.toLocaleString("id-ID")} KM
              </span>
            </span>
          </div>

          <div className="row-start-center gap-2">
            <i className="pi pi-exclamation-triangle text-gray-500" />
            <span className="text-sm text-gray-600">
              Next:{" "}
              <span className="font-semibold text-gray-900">
                {next?.toLocaleString("id-ID")} KM
              </span>
            </span>
          </div>

          <div className="row-start-center gap-2">
            <i className="pi pi-ban text-gray-500" />
            <span className="text-sm text-gray-600">
              Batas KM:{" "}
              <span className="font-semibold text-gray-900">
                {lastkm?.toLocaleString("id-ID")} KM
              </span>
            </span>
          </div>
        </div>

        {/* --- Diff Tag --- */}
        <div className="pt-3">
          <span
            className={`${bgColor} rounded-xl px-3 py-1 text-xs font-bold text-black`}
          >
            {formatted} KM
          </span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`col-start-start bg-white shadow-md rounded-md p-3 w-full`}
    >
      <div className="row-start-center gap-2 pb-4">
        <span
          className={`font-semibold tracking-wider text-slate-600 text-sm `}
        >
          Warning Service
        </span>
      </div>
      <div className="col-start-start w-full gap-2">
        <span className="text-slate-400 text-sm">
          List kendaraan yang sudah harus di-service
        </span>
        {!isMobile && (
          <DataTable
            className="w-full"
            size="small"
            value={data}
            dataKey="id"
            cellClassName={() => (isMobile ? "text-sm" : "")}
          >
            <Column
              headerClassName="text-sm"
              field="data_kendaraan.nomor_polisi"
              header="NO POLISI"
              body={mobilBodyTemplate}
            />
            <Column
              headerClassName="text-sm"
              field="data_service.nama"
              header="SERVICE"
              body={serviceBodyTemplate}
            />
            <Column
              headerClassName="text-sm"
              field="data_kendaraan.speedo_akhir"
              align="right"
              header="KM AKHIR"
              body={kmAkhirBodyTemplate}
            />
            <Column
              headerClassName="text-sm"
              field="next"
              align="right"
              header="NEXT"
              body={nextBodyTemplate}
            />
            {/* {!isMobile && ( */}
            <Column
              headerClassName="text-sm"
              align="right"
              header="Status"
              body={statusBodyTemplate}
              bodyStyle={{ textAlign: "right" }}
            />
            {/* )} */}
          </DataTable>
        )}
        {isMobile && (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              showGridlines
              stripedRows
              value={data}
            >
              <Column
                header="Deskripsi Warning Service"
                body={mobileBodyTemplate}
              />
            </DataTable>
          </>
        )}
      </div>
    </div>
  );
};

export default TabelService;
